import { REST_DAY_TYPE_TO_TRANSLATION_KEY } from '../constants'
import { RestDay } from '../types'

export const isRestDay = (obj: { dayType: string }): obj is RestDay => {
  return Object.hasOwn(REST_DAY_TYPE_TO_TRANSLATION_KEY, obj.dayType)
}
